import { EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';

import useAccessForTask from '../hooks/useAccessForTask';
import { ItemTaskType } from '../types';

export interface ICalendarTableCustomButtonEditView {
    task?: ItemTaskType;
    onClick?: (data: any, dataRaw: any) => void;
    data: any;
}

export const CalendarTableCustomButtonEditView: React.FC<ICalendarTableCustomButtonEditView> = ({
    task,
    onClick,
    data,
}) => {
    const access = useAccessForTask(task as ItemTaskType, [
        'schedule-task.assignee.edit',
        'schedule-task.assignee.create',
        'schedule-task.assignee.manage',
        'schedule-task.all.edit',
        'schedule-task.all.create',
        'schedule-task.all.manage',
        'schedule-task.owner.edit',
        'schedule-task.owner.create',
        'schedule-task.owner.manage',
    ]);

    return (
        <>
            <Tooltip title={access ? 'Edit Item' : 'View Item'}>
                <Button
                    shape="circle"
                    icon={access ? <EditOutlined /> : <EyeOutlined />}
                    type={'default'}
                    color={'default'}
                    onClick={() => onClick?.(data, task)}
                />
            </Tooltip>
        </>
    );
};
